import { createUseStyles } from '@glu/theming';

const styles = () => ({
  input: {
    '& input': {
      textAlign: 'right'
    }
  }
});

export default createUseStyles(styles);
